import { render, staticRenderFns } from "./TableContent.vue?vue&type=template&id=61108d2c&scoped=true&"
import script from "./TableContent.vue?vue&type=script&lang=js&"
export * from "./TableContent.vue?vue&type=script&lang=js&"
import style0 from "./TableContent.vue?vue&type=style&index=0&id=61108d2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61108d2c",
  null
  
)

export default component.exports